/* eslint no-undef: "off" */
export default {
  availableFundHideList: {
    stock: {
      value: 'STOCK',
      showBalance: true
    },
    futures: {
      value: 'FUTURES',
      showBalance: true
    },
    fund: {
      value: 'FUND',
      showBalance: true
    },
    mfforex: {
      value: 'FOREX',
      showBalance: true
    },
    mt5forex: {
      value: 'FOREX',
      showBalance: true
    },
    ib: {
      value: 'IB',
      showBalance: false
    },
    pm: {
      value: 'PM',
      showBalance: true
    }
  },
  /**
   *
   */
  tradeAccountConfig: {
    securitiesCash: {
      type: 'STOCK', // 表明类型
      tradeAccountType: 'securitiesCash',
      showBalance: true, // 是否显示余额
      isTradeAccountExit: true,
      isShowExchange: true, // 是否可换汇
      isShowTransfer: true, // 是否可转账
      balance: { // 显示余额名称
        equity: true,
        balance: true
      },
      currency: { // 对应的币种
        value: 'HKD',
        icon: 'HK$'
      }
    },
    securitiesMargin: {
      value: 'STOCK',
      tradeAccountType: 'securitiesMargin',
      showBalance: true,
      isShowExchange: true,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        equity: true,
        balance: true
      },
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    securitiesAyersCash: {
      value: 'STOCK',
      tradeAccountType: 'securitiesAyersCash',
      showBalance: true,
      isShowExchange: true,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        equity: true,
        balance: true
      },
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    futuresDayTradingMargin: {
      value: 'FUTURES',
      tradeAccountType: 'futuresDayTradingMargin',
      showBalance: true,
      isShowExchange: true,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        todayBalance: true
      },
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    futuresDaytradingMargin: {
      value: 'FUTURES',
      tradeAccountType: 'futuresDaytradingMargin',
      showBalance: true,
      isShowExchange: true,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        todayBalance: true
      },
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    futuresMargin: {
      value: 'FUTURES',
      tradeAccountType: 'futuresMargin',
      showBalance: true,
      isShowExchange: true,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        todayBalance: true
      },
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    mf: {
      value: 'FOREX',
      tradeAccountType: 'mf',
      showBalance: true,
      isShowExchange: false,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        accountBalance: true,
        accountInterests: true
      },
      currency: {
        value: 'USD',
        icon: '$'
      }
    },
    mt5: {
      value: 'FOREX',
      tradeAccountType: 'mt5',
      showBalance: true,
      isShowExchange: false,
      isShowTransfer: true,
      isTradeAccountExit: true,
      balance: {
        accountBalance: true,
        accountInterests: true
      },
      currency: {
        value: 'USD',
        icon: '$'
      }
    },
    fundCash: {
      value: 'FUND',
      tradeAccountType: 'fundCash',
      showBalance: true, // 是否显示余额
      isTradeAccountExit: true,
      isShowExchange: true, // 是否可换汇
      isShowTransfer: true, // 是否可转账
      balance: { // 显示余额名称
        equity: true,
        balance: true
      },
      currency: { // 对应的币种
        value: 'HKD',
        icon: 'HK$'
      }
    },
    interactiveBrokerIntegratedMargin: {
      value: 'IB',
      tradeAccountType: 'interactiveBrokerIntegratedMargin',
      showBalance: false,
      isShowExchange: false,
      isShowTransfer: true,
      isTradeAccountExit: true,
      currency: {
        value: 'HKD',
        icon: 'HK$'
      }
    },
    bullionMargin: {
      value: 'PM',
      tradeAccountType: 'bullionMargin',
      showBalance: true,
      isShowExchange: false,
      isShowTransfer: false,
      isTradeAccountExit: true,
      balance: {
        accountBalance: true,
        accountInterests: true
      },
      currency: {
        value: 'USD',
        icon: '$'
      }
    },
    default: {
      value: 'default',
      tradeAccountType: 'default',
      isTradeAccountExit: false,
      isShowExchange: false,
      isShowTransfer: false,
      showBalance: false,
      balance: {
        accountBalance: false,
        accountInterests: false
      },
      currency: {
        value: '',
        icon: ''
      }
    }
  },
  baseCurrency: 'HKD',
  withdrawalCurrencyIocn: 'HK$',
  inCurrencyIocn: 'HK$'

}
